import ExpenseList from './expense_list';

export default ExpenseList;
